import React from 'react';
import UserLayout from '../../components/Layout/UserLayout';
import CompleteProfile from './completeProfile';
import { setSiteSettings } from '../../actions/siteSettings';

const title = 'Profil vervollständigen';

export default {

  path: '/user/completeprofile',

  async action({ store }) {

    // From Redux Store
    let isAuthenticated = store.getState().runtime.isAuthenticated;


    if (!isAuthenticated) {
      return { redirect: '/login' };
    }

    await store.dispatch(setSiteSettings());
    return {
      title,
      component: <CompleteProfile title={title} />
    };
  },

};
